webpackJsonp([163216947426909],{

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdmissionCountry = function AdmissionCountry(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "Details__Wrapper" },
	    _react2.default.createElement(
	      "div",
	      { className: "Details fix" },
	      _react2.default.createElement(
	        "div",
	        { className: "Details__Box" },
	        props.map && _react2.default.createElement("img", { className: "map", src: props.map.file.url, alt: props.map.description }) /*style={{ background:`url(${props.map.file.url}) no-repeat center` }} />*/,
	        _react2.default.createElement(
	          "a",
	          { style: { padding: '6px 30px', marginTop: '6px' }, className: "button", href: props.link.link },
	          props.link.text
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "Details__Box__Items" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              props.title1,
	              ":"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              props.length
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              props.title2,
	              ":"
	            ),
	            _react2.default.createElement("p", { dangerouslySetInnerHTML: { __html: props.destinations } })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              props.title3,
	              ":"
	            ),
	            _react2.default.createElement("p", { dangerouslySetInnerHTML: { __html: props.tuition } })
	          ),
	          props.title4 && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              props.title4,
	              ":"
	            ),
	            props.description4 && _react2.default.createElement("p", { dangerouslySetInnerHTML: { __html: props.description4 } })
	          )
	        ),
	        props.academy && _react2.default.createElement(
	          "p",
	          { className: "disclaimer" },
	          "If the $500 deposit is prohibitive you can request to be considered for a Shawn Mendes Foundation Scholarship with demonstrated need."
	        )
	      )
	    )
	  );
	};
	
	exports.default = AdmissionCountry;
	module.exports = exports["default"];

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"BannerLink":"src-components-BannerLink----BannerLink-module---BannerLink---2_9Y5","ReducedBannerLink":"src-components-BannerLink----BannerLink-module---ReducedBannerLink---23mYG","Button":"src-components-BannerLink----BannerLink-module---Button---1OSVf"};

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _marked = __webpack_require__(11);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _BannerLinkModule = __webpack_require__(374);
	
	var _BannerLinkModule2 = _interopRequireDefault(_BannerLinkModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannerLink = function BannerLink(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: props.reducedPadding ? _BannerLinkModule2.default.ReducedBannerLink : _BannerLinkModule2.default.BannerLink },
	    _react2.default.createElement(
	      'h2',
	      { className: 'h2', style: props.alignCenter ? { textAlign: 'center' } : {} },
	      props.title
	    ),
	    props.content && _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(props.content) }, style: props.alignCenter ? { textAlign: 'center' } : {} }),
	    _react2.default.createElement(
	      'a',
	      { href: props.link, className: _BannerLinkModule2.default.Button },
	      props.linkText
	    )
	  );
	};
	
	exports.default = BannerLink;
	module.exports = exports['default'];

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Hero":"src-components-Destination-Hero----Hero-module---Hero---39f9i","Hero__Wrapper":"src-components-Destination-Hero----Hero-module---Hero__Wrapper---2_xNt","Hero__Title":"src-components-Destination-Hero----Hero-module---Hero__Title---ZH3s-","Hero__Title__Reduced":"src-components-Destination-Hero----Hero-module---Hero__Title__Reduced---1HIGC","Hero__Title__Academy":"src-components-Destination-Hero----Hero-module---Hero__Title__Academy---TW1n3","Hero__Info":"src-components-Destination-Hero----Hero-module---Hero__Info---3HfGE"};

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeroModule = __webpack_require__(307);
	
	var _HeroModule2 = _interopRequireDefault(_HeroModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var academyPages = ['/academy', '/academy/', '/academy/interest', '/academy/interest/', '/academy/tuition', '/academy/tuition/', '/academy/experience', '/academy/experience/'];
	var Hero = function Hero(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page-hero ' + _HeroModule2.default.Hero + (academyPages.includes(props.location) || props.admissionsTemplate ? ' academy' : '') },
	    _react2.default.createElement(
	      'div',
	      { className: _HeroModule2.default.Hero__Wrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _HeroModule2.default.Hero__Info },
	        _react2.default.createElement(
	          'div',
	          { className: academyPages.includes(props.location) || props.admissionsTemplate ? _HeroModule2.default.Hero__Title__Academy : _HeroModule2.default.Hero__Title },
	          _react2.default.createElement('h1', { dangerouslySetInnerHTML: { __html: props.title } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'iframe-wrap' },
	          _react2.default.createElement('iframe', { src: 'https://www.youtube.com/embed/X2e2Sa9y54Y?rel=0', frameBorder: '0', allowFullScreen: true })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          props.description
	        )
	      )
	    )
	  );
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeroModule = __webpack_require__(307);
	
	var _HeroModule2 = _interopRequireDefault(_HeroModule);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var academyPages = ['/academy', '/academy/', '/academy/interest', '/academy/interest/', '/academy/experience', '/academy/experience/'];
	var Hero = function Hero(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page-hero ' + _HeroModule2.default.Hero + (academyPages.includes(props.location) || props.admissionsTemplate ? ' academy' : '') },
	    _react2.default.createElement(
	      'div',
	      { className: _HeroModule2.default.Hero__Wrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _HeroModule2.default.Hero__Info },
	        _react2.default.createElement(
	          'div',
	          { className: academyPages.includes(props.location) || props.admissionsTemplate ? _HeroModule2.default.Hero__Title__Academy : _HeroModule2.default.Hero__Title },
	          _react2.default.createElement('h1', { dangerouslySetInnerHTML: { __html: props.title } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'hero-img-wrap' },
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: props.featuredImage.sizes, alt: props.featuredImage.title }),
	          props.caption && _react2.default.createElement(
	            'p',
	            { className: 'small-hero-caption' },
	            props.caption
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          props.description
	        )
	      )
	    )
	  );
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 740:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Fellows":"src-components-Shared-AdmissionsCards----AdmissionsCards-module---Fellows---1Z4r3","Fellows__Wrapper":"src-components-Shared-AdmissionsCards----AdmissionsCards-module---Fellows__Wrapper---16XIT","BlogCards":"src-components-Shared-AdmissionsCards----AdmissionsCards-module---BlogCards---1JnBo","BlogCard":"src-components-Shared-AdmissionsCards----AdmissionsCards-module---BlogCard---2gRCT","BlogCard__Text":"src-components-Shared-AdmissionsCards----AdmissionsCards-module---BlogCard__Text---3aioy","BlogCard__Details":"src-components-Shared-AdmissionsCards----AdmissionsCards-module---BlogCard__Details---1rSJ2","BlogCard__Author":"src-components-Shared-AdmissionsCards----AdmissionsCards-module---BlogCard__Author----y-FA","hoverlink":"src-components-Shared-AdmissionsCards----AdmissionsCards-module---hoverlink---qLKkG","SelectArrow":"src-components-Shared-AdmissionsCards----AdmissionsCards-module---SelectArrow---1o8N2","SelectArrow__Prev":"src-components-Shared-AdmissionsCards----AdmissionsCards-module---SelectArrow__Prev---1qYES","SelectArrow__Next":"src-components-Shared-AdmissionsCards----AdmissionsCards-module---SelectArrow__Next---5TS45"};

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdmissionsCardsModule = __webpack_require__(740);
	
	var _AdmissionsCardsModule2 = _interopRequireDefault(_AdmissionsCardsModule);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardSlider = function (_React$Component) {
	  _inherits(CardSlider, _React$Component);
	
	  function CardSlider(props) {
	    _classCallCheck(this, CardSlider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      selectedIndex: 0
	    };
	
	    _this.updateSelected = _this.updateSelected.bind(_this);
	    return _this;
	  }
	
	  CardSlider.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var Flickity = __webpack_require__(309);
	    var carousel = document.querySelector('#fellowsSlider');
	    var options = {
	      cellSelector: '.fellowsCard',
	      contain: true,
	      initialIndex: 0,
	      adaptiveHeight: true,
	      accessibility: true,
	      wrapAround: true,
	      pageDots: false,
	      prevNextButtons: false,
	      lazyLoad: true
	    };
	
	    window.setTimeout(function () {
	      _this2.flkty = new Flickity(carousel, options);
	      _this2.flkty.on('cellSelect', _this2.updateSelected);
	      window.setTimeout(function () {
	        _this2.flkty.resize();
	      }, 500);
	    }, 500);
	  };
	
	  CardSlider.prototype.updateSelected = function updateSelected() {
	    var index = this.flkty.selectedIndex;
	    this.setState({
	      selectedIndex: index
	    });
	  };
	
	  CardSlider.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.flkty) {
	      this.flkty.off('cellSelect', this.updateSelected);
	      this.flkty.destroy();
	    }
	  };
	
	  CardSlider.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: _AdmissionsCardsModule2.default.Fellows + ' country-slide-wrap ' + (this.props.className ? ' ' + this.props.className + ' ' : ''), style: this.props.style, id: this.props.id },
	      _react2.default.createElement(
	        'div',
	        { className: _AdmissionsCardsModule2.default.Fellows__Wrapper },
	        _react2.default.createElement(
	          'div',
	          { onClick: function onClick() {
	              return _this3.flkty.previous();
	            }, className: _AdmissionsCardsModule2.default.SelectArrow + ' ' + _AdmissionsCardsModule2.default.SelectArrow__Prev + ' flick-arrow flick-arrow-left' },
	          _react2.default.createElement('img', { src: '/images/icon-circle-arrow.svg', alt: 'circle arrow' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AdmissionsCardsModule2.default.BlogCards, id: 'fellowsSlider' },
	          this.props.cards.map(function (card, i) {
	            return _react2.default.createElement(
	              'div',
	              { className: _AdmissionsCardsModule2.default.BlogCard + ' fellowsCard', key: i },
	              _react2.default.createElement(_gatsbyImage2.default, { sizes: card.backgroundImage.sizes, alt: card.backgroundImage.title }),
	              _react2.default.createElement(
	                'div',
	                { className: _AdmissionsCardsModule2.default.BlogCard__Text },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  card.title
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  card.description
	                )
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { onClick: function onClick() {
	              return _this3.flkty.next();
	            }, className: _AdmissionsCardsModule2.default.SelectArrow + ' ' + _AdmissionsCardsModule2.default.SelectArrow__Next + ' flick-arrow flick-arrow-right' },
	          _react2.default.createElement('img', { src: '/images/icon-circle-arrow.svg', alt: 'circle arrow' })
	        )
	      )
	    );
	  };
	
	  return CardSlider;
	}(_react2.default.Component);
	
	exports.default = CardSlider;
	module.exports = exports['default'];

/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.admissionsQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Apply = __webpack_require__(20);
	
	var _Apply2 = _interopRequireDefault(_Apply);
	
	var _BannerLink = __webpack_require__(336);
	
	var _BannerLink2 = _interopRequireDefault(_BannerLink);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _AdmissionCountry = __webpack_require__(514);
	
	var _AdmissionCountry2 = _interopRequireDefault(_AdmissionCountry);
	
	var _gsap = __webpack_require__(29);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _Hero = __webpack_require__(337);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _VideoHero = __webpack_require__(532);
	
	var _VideoHero2 = _interopRequireDefault(_VideoHero);
	
	var _BannerImage = __webpack_require__(63);
	
	var _BannerImage2 = _interopRequireDefault(_BannerImage);
	
	var _marked = __webpack_require__(11);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _AdmissionsSignup = __webpack_require__(294);
	
	var _AdmissionsSignup2 = _interopRequireDefault(_AdmissionsSignup);
	
	var _Signup = __webpack_require__(70);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _AdmissionsCards = __webpack_require__(547);
	
	var _AdmissionsCards2 = _interopRequireDefault(_AdmissionsCards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var admissions = function (_React$Component) {
		_inherits(admissions, _React$Component);
	
		function admissions() {
			_classCallCheck(this, admissions);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		admissions.prototype.componentDidMount = function componentDidMount() {
			var location = this.props.location.pathname;
			var scriptLocation = 'https://assets.calendly.com/assets/external/widget.js';
	
			if (typeof window !== 'undefined') {
				if (location == '/academy/parents/' || location == '/academy/parents') {
					var scriptElement = document.createElement('script');
					scriptElement.src = scriptLocation;
					this.refs.scriptLocation.appendChild(scriptElement);
				}
			}
		};
	
		admissions.prototype.render = function render() {
			var _this2 = this;
	
			var academyPages = ['/academy', '/academy/', '/academy/interest', '/academy/interest/', '/academy/experience', '/academy/experience/'];
			var page = this.props.data.page;
	
			var node = page.edges[0].node;
			var pageSlug = this.props.location.pathname;
	
			// console.log('THE PAGE SLUG ==== ', pageSlug, academyPages, node.admissionsTemplate);
			// console.log('page slug == ', pageSlug)
			return _react2.default.createElement(
				'div',
				{ className: 'page-admissions' + (academyPages.includes(pageSlug) || node.admissionsTemplate ? ' gcy-institute' : '') },
				_react2.default.createElement(_CustomHelmet2.default, { data: node.seoData }),
				node.map && _react2.default.createElement(_AdmissionCountry2.default, {
					map: node.map,
					title1: node.itemTitle1,
					length: node.length,
					title2: node.itemTitle2,
					destinations: node.destinations,
					title3: node.itemTitle3,
					tuition: node.tuition,
					title4: node.itemTitle4,
					description4: node.description4,
					link: node.buttonLink,
					academy: node.admissionsTemplate ? node.admissionsTemplate : academyPages.includes(pageSlug)
				}),
				pageSlug == '/academy' || pageSlug == '/academy/' && _react2.default.createElement(
					'div',
					{ className: 'hero-wrap' },
					_react2.default.createElement(_VideoHero2.default, {
						title: node.pageTitle,
						description: node.mainDescription.mainDescription,
						location: pageSlug,
						admissionsTemplate: node.admissionsTemplate })
				),
				pageSlug != '/academy' && pageSlug != '/academy/' && _react2.default.createElement(
					'div',
					{ className: 'hero-wrap' },
					_react2.default.createElement(_Hero2.default, {
						title: node.pageTitle,
						featuredImage: node.heroImage,
						caption: node.heroCaption,
						description: node.mainDescription.mainDescription,
						location: pageSlug,
						admissionsTemplate: node.admissionsTemplate ? node.admissionsTemplate : false
					})
				),
				node.flexSections.length > 0 && node.flexSections.map(function (section, index) {
					return _react2.default.createElement(
						'span',
						{ key: index },
						_react2.default.createElement(
							'div',
							{ className: 'section' },
							_react2.default.createElement(
								_Row2.default,
								{ className: 'no-padding section-content' + (section.cardView === true ? ' card-section no-padding-top no-padding-bottom pull-up-40' : '') },
								_react2.default.createElement(
									'div',
									{ className: 'inner' },
									section.sectionTitle && section.cardView !== true && _react2.default.createElement('h2', {
										className: 'h2',
										dangerouslySetInnerHTML: {
											__html: section.sectionTitle
										}
									}),
									section.sectionItems.length && section.cardView === true && _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(_AdmissionsCards2.default, {
											cards: section.sectionItems
										})
									),
									section.sectionItems.length && section.cardView !== true && section.sectionItems.map(function (item, index) {
										return _react2.default.createElement(
											'span',
											{ id: item.hashId ? item.hashId : '', key: index, className: 'section-group' },
											item.title && _react2.default.createElement('h3', {
												className: 'h3',
												dangerouslySetInnerHTML: { __html: item.title }
											}),
											item.text && _react2.default.createElement('span', {
												dangerouslySetInnerHTML: {
													__html: (0, _marked2.default)(item.text.text)
												}
											}),
											item.question && _react2.default.createElement('h3', {
												className: 'h3',
												dangerouslySetInnerHTML: {
													__html: item.question
												}
											}),
											item.answer && _react2.default.createElement('span', {
												dangerouslySetInnerHTML: {
													__html: (0, _marked2.default)(item.answer.answer)
												}
											})
										);
									})
								)
							),
							section.bannerImage && _react2.default.createElement(
								'span',
								null,
								_this2.props.location.pathname === "/tech-for-good-scholarship/" && _react2.default.createElement(
									'div',
									{ className: 'apply-wrap' },
									_react2.default.createElement(_BannerLink2.default, {
										title: 'Educators - Nominate your Students!',
										content: '<p style=\'text-align:center;\'>If you\'re a teacher, share this unique opportunity with your students<br/>by nominating them to apply for Global Citizen Year!</p>',
										linkText: 'Nominate a Student',
										link: '/nominate-a-student/',
										alignCenter: true,
										reducedPadding: true
									})
								),
								_react2.default.createElement(
									'div',
									{ className: 'banner-wrap', style: _this2.props.location.pathname === "/tech-for-good-scholarship/" ? { marginTop: 0 } : {} },
									_react2.default.createElement(_BannerImage2.default, { image: section.bannerImage })
								)
							)
						)
					);
				}),
				node.faqItem && _react2.default.createElement(
					_Row2.default,
					{ className: 'no-padding section-content' },
					_react2.default.createElement(
						'div',
						{ className: 'inner' },
						node.faqSectionTitle && _react2.default.createElement('h2', {
							className: 'h2',
							dangerouslySetInnerHTML: { __html: node.faqSectionTitle }
						}),
						node.faqItem && node.faqItem.length && node.faqItem.map(function (item, index) {
							return _react2.default.createElement(
								'div',
								{ className: 'section-group flex-faq', key: index },
								item.question && _react2.default.createElement('h3', {
									className: 'h3',
									dangerouslySetInnerHTML: {
										__html: item.question
									}
								}),
								item.answer && _react2.default.createElement('p', {
									dangerouslySetInnerHTML: {
										__html: (0, _marked2.default)(item.answer.answer)
									}
								})
							);
						}),
						node.link && node.link.link && node.link.text && _react2.default.createElement(
							'a',
							{ className: 'hoverlink', href: '' + node.link.link },
							node.link.text
						)
					)
				),
				!academyPages.includes(pageSlug) && !node.showAdmissionsRfi && _react2.default.createElement(
					'div',
					{ className: 'apply-wrap' },
					_react2.default.createElement(_Apply2.default, {
						title: 'It\'s time to break out from the expected',
						buttonUrl: '/apply/'
					})
				),
				(pageSlug == '/academy/interest' || pageSlug == '/academy/interest/' || node.showAdmissionsRfi) && _react2.default.createElement(
					'div',
					{ style: { zIndex: '50', position: 'relative' }, id: 'signup' },
					_react2.default.createElement(_Signup2.default, {
						title: node.admissionsRfiText ? node.admissionsRfiText : "Sign up for more!",
						location: this.props.location,
						color: 'Black'
					})
				),
				_react2.default.createElement('div', { ref: 'scriptLocation' })
			);
		};
	
		return admissions;
	}(_react2.default.Component);
	
	exports.default = admissions;
	var admissionsQuery = exports.admissionsQuery = '** extracted graphql fragment **';
	
	//
	// map {
	//   file {
	//     url
	//     contentType
	//     fileName
	//   }
	//   title
	// }

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-admissions-js-51d9bc0b3ef57c590d55.js